<template>
  <div v-if="gameInfo.gamePropertyList && gameInfo.gamePropertyList.length">
    <div class="type-title">技能屬性</div>
    <div class="cell-list"> 
      <el-popover
        v-for="(game, i) in gameInfo.gamePropertyList"
        :key="'game-property-' + game.propertyCode"
        placement="bottom"
        v-model="showPopover[i]"
        class="cell-wrap-popover"
        popper-class="popper-clear-style"
        trigger="click"
      >
        <div class="property-wrap">
          <div
            v-for="(l, j) in game.propertyValueList"
            :key="'row-' + j"
            class="rows pointer"
            :class="isSelected(game.propertyCode, l) && 'selected'"
            @click="select(game.propertyCode, l, i)"
          >
            {{ l }}
          </div>
        </div>
        <CellItem
          slot="reference"
          class="cell-wrap"
          :textLeft="game.propertyName"
          :textRight="getSkillProperty(game.propertyCode)"
          :textLight="getLight(game.propertyCode)"
        />
      </el-popover>
    </div>
  </div>
</template>
<script>
import CellItem from './cells'
export default {
  components: {
    CellItem,
  },
  props: {
    skillInfo: Object,
    gameInfo: Object,
  },
  data() {
    return {
      showPopover: null,
    }
  },
  created() {
    const { gamePropertyList } = this.gameInfo
    if (gamePropertyList && gamePropertyList.length) {
      this.showPopover = new Array(gamePropertyList.length).fill(false)
    }
  },
  computed: {
  },
  methods: {
    getSkillProperty(code) {
      const { gamePropertyMap } = this.skillInfo
      if (gamePropertyMap && gamePropertyMap[code] && gamePropertyMap[code].propertyValueList.length) {
        return gamePropertyMap[code].propertyValueList.join('/')
      }
      return '未設置'
    },
    getLight(code) {
      const { gamePropertyMap } = this.skillInfo
      if (gamePropertyMap && gamePropertyMap[code] && gamePropertyMap[code].propertyValueList.length) {
        return true
      }
      return false
    },
    isSelected(code, value) {
      const { gamePropertyMap } = this.skillInfo
      return gamePropertyMap && gamePropertyMap[code] && gamePropertyMap[code].propertyValueList.some(item => item === value)
    },
    select(code, value, i) {
      let { gamePropertyMap } = this.skillInfo
      if (!gamePropertyMap) {
        gamePropertyMap = {}
      }
      if (!gamePropertyMap[code]) {
        const { propertyCode, propertyName } = this.gameInfo.gamePropertyList[i]
        gamePropertyMap[code] = { propertyCode, propertyName, propertyValueList: [value] }
      } else {
        const list = gamePropertyMap[code].propertyValueList
        const index = list.findIndex(item => item === value)
        if (index !== -1) {
          list.splice(index, 1)
        } else {
          gamePropertyMap[code].propertyValueList.push(value)
        }
      }
      this.$emit('setSkillInfo', { gamePropertyMap })
    }
  }
}
</script>
<style lang="scss" scoped>
  .property-wrap {
    background: #FFFFFF;
    border-radius: 8px;
    overflow: hidden;
    .rows {
      width: 434px;
      height: 38px;
      line-height: 38px;
      text-align: center;
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      &.selected {
        background: #F6F6F6;
      }
    }
  }
  .dialog-set-skill-wrap /deep/ .dialog-set-skill {
    width: 420px;
  }
  .dialog-set-skill-wrap /deep/ .dialog-wrap {
    background: #FFFFFF;
    border-radius: 8px;
    width: 420px;
    .dialog-title {
      @include flex(space-between);
      font-weight: 500;
      font-size: 18px;
      line-height: 25px;
      color: $color-gray-1;
      border-bottom: 1px solid #E0E0E0;
      height: 64px;
      padding: 0 18px 0 30px;
    }
    .dialog-content {
      padding: 16px 30px 30px;
      .tip-text {
        font-size: 14px;
        line-height: 20px;
        color: $color-gray-3;
        margin-bottom: 16px;
      }
      .set-price {
        @include flex();
        height: 104px;
        padding: 28px 30px 30px;
        position: relative;

        .price {
          position: relative;
          flex: 1;
          height: 40px;
          font-size: 14px;
          font-weight: 500;
          line-height: 22px;

          span {
            position: absolute;
            left: 12px;
            top: 9px;
          }

          input {
            height: 40px;
            border: 1px solid #999999;
            border-radius: 4px;
            padding-left: 25px;

            &:focus {
              border: none;
              box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.2);
            }
          }

          .error-line {
            font-size: 12px;
            line-height: 17px;
            font-weight: 500;
            color: #FD2243;
            margin-top: 4px;
          }
        }
        .unit-button {
          height: 40px;
          background: #FFFFFF;
          border: 1px solid #999999;
          box-sizing: border-box;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 15px 0 9px;
          font-size: 14px;
          line-height: 20px;
          color: $color-gray-1;
          .no-unit {
            color: $color-gray-2;
          }
          img {
            width: 10px;
            transition: all .3s;
            &.active {
              transform: rotate(180deg);
            }
          }
        }
        .select-unit {
          margin-left: 16px;
          flex: 1;
        }
      }
    }
  }
  .type-title {
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: $color-gray-1;
    margin-top: 30px;
  }
  .cell-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .cell-wrap-popover:nth-child(odd) {
      margin-right: 28px;
    }
    .cell-wrap {
      width: 435px;
      height: 62px;
      margin: 10px 0;
    }
  }
</style>
